

import { Injectable, Inject } from '@angular/core';
import service = require("./breeze.entitymanager.service");
import base = require("./base.dataservice");
//import { Predicate } from 'breeze';

export function initialize(module: ng.IModule) {
    module.service(ActivityDataService.Id, ActivityDataService);

    ActivityDataService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}

@Injectable()
export class ActivityDataService extends base.BaseDataService<Nema.Crew.Model.Activity> implements IActivityDataService {

    constructor(
        @Inject("entityManagerService") entityManagerService: service.EntityManagerService,
        @Inject("breeze") breeze,
        @Inject("$log") $log,
        @Inject("$q") $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }

    public static Id = "activityDataService";

    public get EntityName(): string {
        return "Activity";
    }

    public get EntitiesName(): string {
        return "Activities";
    }

    /**
 * Gets all the entities.
 */
    public getSome(workPlaceId: number/*, _year: number = null, _month: number = null*/): ng.IPromise<Nema.Crew.Model.Activity[]> {

        var self = this;

        //var predicates: any;

        //var p1 = new Predicate("WorkplaceId", "==", workPlaceId);

        //// Multiple Where: http://breeze.github.io/doc-js/query-examples.html
        //if (_year != null && _month != null) {
        //    var date = "01-" + _month + "-" + _year;
        //    var startDate = new Date(date);
        //    var endDate = startDate.setMonth(startDate.getMonth() + 1);

        //    var p2 = new Predicate("Day", ">", startDate);
        //    var p3 = new Predicate("Day", "<=", endDate);

        //    predicates = Predicate.and([p1, p2, p3]);
        //} else {
        //    predicates = Predicate.and([p1]);
        //}

        var entityQuery = self.createEntityQuery()
            .where("WorkplaceId", "==", workPlaceId)
            //.where(predicates)
            .orderBy("Day asc")
            .using(this.entityManager);

        var promise = entityQuery.execute()
            // ignore remote query results and chain to local query. Discarded the query results ... but items remain in cache
            .then(() => {
                self.entityCollection = entityQuery.using(self.breeze.FetchStrategy.FromLocalCache).executeLocally();
                return <Nema.Crew.Model.Activity[]><any>self.entityCollection;
            });

        return promise;
    }
}

export interface IActivityDataService extends base.IDataService<Nema.Crew.Model.Activity> {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/activity.dataservice .ts